import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "js-main-content" }
const _hoisted_2 = { class: "gfu-profile-view" }
const _hoisted_3 = {
  key: 1,
  class: "gfu-layout__main gfu-layout__main--extranarrow"
}
const _hoisted_4 = { class: "_mt-3" }
const _hoisted_5 = { class: "_mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_secondary_navigation_bar = _resolveComponent("secondary-navigation-bar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_base_button = _resolveComponent("base-button")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_secondary_navigation_bar, {
      navigation: $options.navigation,
      "data-qa-prefix": "profile"
    }, null, 8 /* PROPS */, ["navigation"]),
    _createElementVNode("div", _hoisted_2, [
      ($props.isPublic)
        ? (_openBlock(), _createBlock(_component_router_view, {
            key: 0,
            name: "profile"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_box, { class: "_mt-6" }, {
              default: _withCtx(() => [
                ($props.isViewingOwnProfile)
                  ? (_openBlock(), _createBlock(_component_empty_state, {
                      key: 0,
                      title: _ctx.Resources.Profile.EmptyStateProfileStatusPrivateTitle,
                      "data-qa": "user-profile:PrivateState"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.Resources.Profile.EmptyStateProfileStatusPrivateOwnProfileParagraph), 1 /* TEXT */),
                        _createVNode(_component_base_button, {
                          tag: "a",
                          href: $options.accountSettingsUrl,
                          class: "_mt-3",
                          theme: "accent",
                          "format-key": "0",
                          "data-qa": "user-profile:ManagePrivacyButton"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Resources.Profile.EmptyStateProfilePrivateStatusOwnProfileAction), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["href"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["title"]))
                  : (_openBlock(), _createBlock(_component_empty_state, {
                      key: 1,
                      title: _ctx.Resources.Profile.EmptyStateProfileStatusPrivateTitle
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.Resources.Profile.EmptyStateProfileStatusPrivateParagraph), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["title"]))
              ]),
              _: 1 /* STABLE */
            })
          ]))
    ])
  ]))
}